import { Injectable } from '@angular/core'
import { StorageNoSql } from './storage-nosql.service'
import { ObjectMapper } from './object_mapper.service'
import { Auth, User, UserProfile, UserProfileType } from '../model/login.model'

// Function is responsible for storing all global variables
@Injectable({
  providedIn: 'root'
}) export class GlobalVariables {

  public auth_global: Auth
  public user_global: User
  public user_profile: UserProfile

  constructor(private storage: StorageNoSql, private objectMapper: ObjectMapper) {
    console.log('Init global var')
  }

  init() {
    console.log('running init')
    return new Promise((resolve, reject) => {
      // Get all global variables
      this.auth_global = this.objectMapper.getdocschema('Auth')
      this.user_global = this.objectMapper.getdocschema('User')
      this.user_profile = this.objectMapper.getdocschema('UserProfile')

      Promise.all([this.getAuthData(), this.getUserData(), this.getProfileData()]).then(() => {
        resolve(true)
      }).catch(() => {
        reject(false)
      })
    })
  }

  clearGlobalData() {
    return new Promise((resolve, reject) => {
      this.auth_global = this.objectMapper.getdocschema('Auth')
      this.user_global = this.objectMapper.getdocschema('User')
      this.user_global = this.objectMapper.getdocschema('UserProfile')
      // Delete session entity
      resolve(true)
    })
  }

  getAuthData() {
    return new Promise((resolve, reject) => {
      this.storage.db_instance.Auth.findOne({ schema_doctype: 'Auth' }, ((data: Auth) => {
        this.auth_global = { ...data }
        resolve(true)
      }), () => {
        reject(false)
      })
    })
  }

  getUserData() {
    return new Promise((resolve, reject) => {
      this.storage.db_instance.User.findOne({ schema_doctype: 'User' }, ((data: User) => {
        this.user_global = { ...data }
        resolve(true)
      }), () => {
        // Error Logging here
        reject(false)
      })
    })
  }

  getProfileData() {
    return new Promise((resolve, reject) => {
      this.storage.db_instance.UserProfile.findOne({ schema_doctype: 'UserProfile' }, ((data: UserProfile) => {
        this.user_profile = { ...data }
        resolve(true)
      }), () => {
        reject(false)
      })
    })
  }

  setAuthData(auth) {
    this.auth_global = { ...auth }
  }

  setUserdata(user) {
    this.user_global = { ...user }
  }

  setUserProfile(userProfile: UserProfileType) {
    this.user_profile = { ...userProfile }
  }
}
